/**
 * Set data to local storage
 * @param key
 * @param value
 */
export const setLocalStorageItem = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * Get data from local storage
 * @param key
 * @returns
 */
export const getLocalStorageItem = (key: string): any | null => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

/**
 * Remove data from local storage
 * @param key
 */
export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};
